import { World } from './world'
import { Renderer } from './renderer'

const canvas = document.getElementById('canvas') as HTMLCanvasElement
let world: World
let renderer: Renderer
let lastTime = 0
let fps = 60
let running = true

function resize(): void {
  canvas.width = window.innerWidth
  canvas.height = window.innerHeight
  if (renderer) renderer.resize(canvas.width, canvas.height)
}

function init(): void {
  resize()
  world = new World(canvas.width, canvas.height)
  renderer = new Renderer(canvas)
}

function loop(now: number): void {
  if (!running) return
  requestAnimationFrame(loop)

  const dt = Math.min((now - lastTime) / 1000, 0.05)
  lastTime = now

  fps = fps * 0.9 + (1 / (dt || 0.016)) * 0.1

  world.update(dt)
  renderer.render(world)
  renderer.renderStats(world, fps)
}

// コントロール
document.getElementById('btn-pause')?.addEventListener('click', () => {
  running = !running
  const btn = document.getElementById('btn-pause')!
  btn.textContent = running ? '⏸ 一時停止' : '▶ 再開'
  if (running) {
    lastTime = performance.now()
    requestAnimationFrame(loop)
  }
})

document.getElementById('btn-reset')?.addEventListener('click', () => {
  world = new World(canvas.width, canvas.height)
})

window.addEventListener('resize', () => {
  resize()
  world = new World(canvas.width, canvas.height)
})

init()
lastTime = performance.now()
requestAnimationFrame(loop)
